import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ListingTitle.scss';

const roleLevelCorrelation = {
  primary: 'h1',
  secondary: 'h2',
  tertiary: 'h3'
};

const ListingTitle = ({ role, children, className = '' }) => {
  const ListingTitleTag =
    roleLevelCorrelation[role] || roleLevelCorrelation.secondary;

  const titleClasses = classNames('listing-title', className);

  return <ListingTitleTag className={titleClasses}>{children}</ListingTitleTag>;
};
// To-DO: Fix ARIA type roles being propagated by listing title
ListingTitle.propTypes = {
  role: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default ListingTitle;
